import { useAuth } from 'react-oidc-context';
import ReportsDatePicker from '../components/OrderDatePicker';
import { OrderHistoryTable } from '../components/OrderHistoryTable';
import { useEffect, useState } from 'react';
import {
  createOrderHistoryReport,
  downloadOrderHistoryReport,
  getOrderReportHistory,
} from '../service';
import { PreviouslyExportedOrderHistory } from '../interface/interface';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { useSocket } from '../hooks/useSocket';
import Loading from '../components/Loading';
import showToast from '../components/ToastComponent';

const Reports = () => {
  const { user } = useAuth();
  const [, isSocketConnected, refreshTrigger] = useSocket(
    user?.access_token as string,
  );
  const [orderHistory, setOrderHistory] = useState<
    Array<PreviouslyExportedOrderHistory>
  >([]);
  const [orderHistoryLoaded, setorderHistoryLoadStatus] = useState(false);
  const [refToDownloadReport, setDownloadReportRef] = useState<
    { refId: string; fileName: string } | undefined
  >();
  const [isDownloading, setDownloadStatus] = useState(false);
  const [dataToGenerateReport, setDataForGenerateReport] = useState<
    { from: Date; to: Date } | undefined
  >();
  const [reportGenerationTableRefreshTrigger, setReportGenerationTrigger] =
    useState<number>(0);

  useEffect(() => {
    if (!user?.access_token) return;
    setorderHistoryLoadStatus(true);

    getOrderReportHistory(user?.access_token).then((data) => {
      if (!data) return;

      if (data.length)
        setOrderHistory(
          data.map(
            (d: any) =>
              ({
                reportId: d.id,
                duration: d.duration,
                status: d.status,
                createdAt: d.createdDate,
                generatedBy: d.generatedBy.email,
              }) as PreviouslyExportedOrderHistory,
          ),
        );

      setorderHistoryLoadStatus(false);
    });
  }, [reportGenerationTableRefreshTrigger, refreshTrigger]);

  useEffect(() => {
    if (!refToDownloadReport || !user?.access_token) return;
    setDownloadStatus(true);

    downloadOrderHistoryReport(
      user.access_token,
      refToDownloadReport.refId,
    ).then((data) => {
      if (!data) return;

      saveAs(data, `${refToDownloadReport.fileName}.xlsx`);
      setDownloadReportRef(undefined);
      setDownloadStatus(false);
    });
  }, [refToDownloadReport]);

  useEffect(() => {
    if (!user?.access_token || !dataToGenerateReport) return;

    createOrderHistoryReport(
      user.access_token,
      dataToGenerateReport.from,
      dataToGenerateReport.to,
    ).then((data) => {
      if (data) return;

      if (data === 201) {
        showToast({
          message: `Added Report generation Task: 
          ${moment(dataToGenerateReport.from).format('DD/MM/YYYY')} to${moment(dataToGenerateReport.to).format('DD/MM/YYYY')}`,
          type: 'success',
        });
      }

      setDataForGenerateReport(undefined);
      setReportGenerationTrigger((prev) => prev + 1);
    });
  }, [dataToGenerateReport]);

  return (
    <div>
      {!isSocketConnected ? (
        <Loading />
      ) : (
        <>
          <h3 className="text-xl font-semibold text-primary-blue-500">
            Generate Report
          </h3>
          <p className="text-black text-sm mt-2 text-primary-blue-500">
            Please specify the timeframe you'd like the report to download.
          </p>
          <ReportsDatePicker
            onClear={() => {
              setDataForGenerateReport(undefined);
            }}
            onExport={(from, to) =>
              setDataForGenerateReport({
                from: moment(from).toDate(),
                to: moment(to).toDate(),
              })
            }
            keyStores={{
              from: '',
              to: '',
            }}
          />
          <h3 className="text-xl font-semibold text-primary-blue-500 mt-10 mb-2">
            Reports history
          </h3>
          <OrderHistoryTable
            data={orderHistory}
            loading={orderHistoryLoaded}
            onDownloadReport={(id: string, fileName: string) =>
              setDownloadReportRef({ refId: id, fileName })
            }
            isDownloaded={isDownloading}
          />
        </>
      )}
    </div>
  );
};
export default Reports;
